import { createContext } from 'react';

const defaultSettings = {
	isBoardMoreObvious: false,
	isOverElementAutoScrollEnabled: true,
	boardScrollSpeed: 'fast',
	columnScrollSpeed: 'standard',
	isFPSPanelEnabled: false,
	isCPUBurnEnabled: false,
	isOverflowScrollingEnabled: true,
};

export const SettingsContext = createContext({
	//fields,
	settings: defaultSettings,
	update: () => {},
	reset: () => {},
});
